import { css } from 'styled-components';
export const baseSidebarElement = css `
  width: 100%;
  text-align: left;
  padding: var(--layout-soybean) var(--layout-sandgrain);
  color: var(--base-text-secondary);
  text-decoration: none;
  cursor: pointer;

  p {
    display: flex;
    align-items: center;
    color: inherit;
  }

  .icon {
    float: left;

    svg {
      width: 16px;
      margin-right: 16px;
      vertical-align: text-bottom;
      float: none;
    }
  }
  .iconSelected {
    display: none;
  }

  &.active,
  &:hover {
    .iconSelected {
      display: initial;
    }

    .iconDefault {
      display: none;
    }
  }

  &:hover {
    color: var(--action-text-hover);
    p {
      color: inherit;
    }
  }

  &.active p {
    font-weight: 600;
  }
  &.active:hover p {
    color: var(--base-icon-secondary);
  }
`;
